import { parseSizeToBytes } from '../../utils/parseSizeToBytes';

const columns = (renderCell, renderActionCell) => {
  return [
    {
      field: 'name',
      headerName: 'Name',
      width: 350,
      hide: false,
      renderCell,
      align: 'center',
      headerAlign: 'center'
    },
    {
      field: 'count',
      headerName: 'Count',
      width: 300,
      renderCell,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'size',
      headerName: 'Size',
      width: 200,
      headerAlign: 'center',
      align: 'center',
      renderCell,
      sortComparator: (a, b) => parseSizeToBytes(a) - parseSizeToBytes(b)
    },
    {
      field: 'storageSize',
      headerName: 'Storage Size',
      width: 300,
      renderCell,
      headerAlign: 'center',
      align: 'center',
      sortComparator: (a, b) => parseSizeToBytes(a) - parseSizeToBytes(b)
    },
    {
      field: 'earliestEntryDate',
      headerName: 'Earliest Entry Date',
      width: 200,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'latestEntryDate',
      headerName: 'Latest Entry Date',
      width: 300,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'Rig',
      headerName: 'Rig',
      width: 300,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'Well',
      headerName: 'Well',
      width: 200,
      renderCell,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 200,
      headerAlign: 'center',
      renderCell: renderActionCell,
      align: 'center'
    }
  ];
};

export default columns;
